import {
    FOOD, WATER, EXERCISE, BLOOD_PRESSURE, STEPS, DIGESTION, CRAVING,
    HUNGER, ENERGY, SLEEP, WEIGHT, HEART_RATE, ADHERENCE
} from 'utils/constants/collectionNames';

export const subCollectionsNames = [
    FOOD, WATER, EXERCISE, BLOOD_PRESSURE, STEPS, DIGESTION, CRAVING,
    HUNGER, ENERGY, SLEEP, WEIGHT, HEART_RATE, ADHERENCE
]